







































































































































































































































































import {Component, Vue, Inject} from 'vue-property-decorator';
import Footer from '../components/Footer.vue'
import TenantSwitch from '../components/tenant-switch.vue'
import LanguageSwitch from '../components/language-switch.vue'
import AbpBase from '../lib/abpbase'
// import md5 from "js-md5";
import axios from 'axios'
import iView from 'iview'


@Component({
	components: {Footer, TenantSwitch, LanguageSwitch}
})
export default class Login extends AbpBase {
	get bodyHeight() {
		return {
			height: (window.innerHeight - 100) + 'px'
		}
	}

	loginHeight = {
		height: '',
	}

	// XT_LOGIN = XT_LOGIN
	tenantId = ""
	loginModel = {
		userNameOrEmailAddress: '',
		password: '',
		rememberMe: false
	}
	showChangeTenant: boolean = false

	created() {
		this.tenantId = abp.utils.getCookieValue("Abp.TenantId")
		let self = this;
		document.onkeydown = function (e) {
			let key = (window.event as any).keyCode;
			if (key == 13) {
				if (!self.showChangeTenant) {
					self.login()
				}
			}
		}
		const currentLanguage = abp.utils.getCookieValue("Abp.Localization.CultureName")
		if (currentLanguage !== "zh-Hans") {
			abp.utils.setCookieValue(
				"Abp.Localization.CultureName",
				"zh-Hans",
				new Date(new Date().getTime() + 5 * 365 * 86400000), //5 year
				abp.appPath
			);
			// setTimeout(location.reload(),2000)
			location.reload();
		}
	}

	sItemlistFlag = false

	tenantList = [
		{value:'医院1',text:'医院1'},
		{value:'医院2',text:'医院2'},
		{value:'医院3',text:'医院3'},
	]
	tenantName= ''
	tenantActive = null
	tenantChange(index){
		this.sItemlistFlag = !this.sItemlistFlag
		this.tenantActive = index
		this.tenantName = this.tenantList[index].text
	}
	
	selectChange(){
		if(window.event){
			window.event.stopPropagation();
		}
		this.sItemlistFlag = !this.sItemlistFlag
	}
	mounted(){
		(iView as any).LoadingBar.finish();
		//select 选择
		this.$nextTick(()=>{
			let self = this;
			document.addEventListener('click',(e)=>{
				self.sItemlistFlag = false
			})
		})


	}


	async login() {
		(this.$refs.loginform as any).validate(async (valid: boolean) => {
			if (valid) {
				this.$Message.loading({
					content: '正在登录',
					duration: 0
				})

				let hisLoginResult = await this.$store.dispatch({
					type: 'app/login',
					data: this.loginModel
				})
				localStorage.setItem("account", this.loginModel.userNameOrEmailAddress)
				localStorage.setItem("password", this.loginModel.password)
				localStorage.setItem("hisLoginResult", hisLoginResult ? "1" : "0")
				let xTLoginResult = false
				let params = {
					account: this.loginModel.userNameOrEmailAddress,
					password: md5(this.loginModel.password),
					tenantId: this.tenantId
				}
				try {
					// let res = await axios.get(`${XT_LOGIN}cheetah/api/sso/checkUser.shtml?account=${params.account}&password=${params.password}&tenantId=${params.tenantId}`)
					// xTLoginResult = res.data.flag
					let res = await axios.get(`${XT_LOGIN}cheetah/api/sso/login.shtml?account=${params.account}&password=${params.password}&tenantId=${params.tenantId}`)
					xTLoginResult = res.data.status == 1
					if (xTLoginResult) {
						abp.utils.setCookieValue(
							"cookie_token",
							res.data.cookie_token,
							new Date(new Date().getTime() + 5 * 365 * 86400000), //5 year
							abp.appPath
						);
						abp.utils.setCookieValue(
							"tenantId",
							this.tenantId,
							new Date(new Date().getTime() + 5 * 365 * 86400000), //5 year
							abp.appPath
						);
					}
				} catch (e) {
					console.log(e)
				}
				localStorage.setItem('xTLoginResult', xTLoginResult ? '1' : '0');
				if (hisLoginResult && xTLoginResult) {
					this.$Message.destroy()
					this.$router.push("sso")
				} else if (!hisLoginResult && !xTLoginResult) {
					this.$Message.error("请检查用户名或密码！")
				} else if (hisLoginResult && !xTLoginResult) {
					location.reload()
				} else {
					(this.$refs.form as any).submit()
					// window.location.href =  XT_LOGIN + 'cheetah/index.shtml'
				}
			}
		});
	}

	get tenant() {
		return this.$store.state.session.tenant;
	}

	rules = {
		userNameOrEmailAddress: [
			{required: true, message: '请输入用户名', trigger: 'blur'}
		],
		password: [
			{required: true, message: '请输入密码', trigger: 'blur'}
		]
	}

}





// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/login2.vue